import React from 'react';
import { Flex, Link, SxProp, Text } from 'theme-ui';
import useCTAStyle from '~/hooks/components/use-cta-style';

type Props = {
  CTA: Queries.CallToActionFragmentFragment | null;
  ctaSubtext: Queries.ActivityPageHeaderFragment['ctaSubtext'];
  forwardSx?: SxProp['sx'];
};

const HeaderCTA = ({ CTA, ctaSubtext, forwardSx }: Props) => {
  const CTAStyles = useCTAStyle({
    baseColor: CTA?.baseColor ?? 'Black',
    size: CTA?.size ?? 'Medium',
    variant: CTA?.variant ?? 'Filled',
    disableDisabledStyle: false,
  }) as SxProp;
  return (
    <Flex sx={{ gridArea: 'cta', flexDirection: 'column', gap: '1.6rem', px: ['2.4rem', 0], ...forwardSx }}>
      <Link
        href={`#${CTA?.innerLink}`}
        variant="text.button"
        sx={{
          ...CTAStyles,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '4.8rem',
        }}
      >
        {CTA?.text}
      </Link>
      <Text
        as="p"
        sx={{
          fontSize: '1.2rem',
          lineHeight: 1.3,
          textAlign: 'center',
        }}
      >
        {ctaSubtext}
      </Text>
    </Flex>
  );
};

export default HeaderCTA;
